import { HostListener, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export abstract class SessionComponentCanDeactivate {
    abstract canDeactivate(): boolean;

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        // if (!this.canDeactivate() && localStorage.getItem('jwtToken') && !this.getrouterChange()) {
        //     this.userService.currentUser.subscribe(
        //         (userData) => {
        //             if (userData) {
        //                 this.userService.logoutuser(userData.item.userAccountId)
        //             }
        //             this.userService.purgeAuth();
        //             location.reload();
        //         })
        // }
    }
    getrouterChange() {
        if (window.performance.navigation.type == window.performance.navigation.TYPE_RELOAD) {
            return false
        } else {
            return true
        }
    }
}